import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'results'];
  static values = { url: String };

  disconnect() {
    clearTimeout(this.timeout);
    this.abortController?.abort();
  }

  search() {
    const query = this.inputTarget.value.trim();
    if (query.length < 2) {
      this.abortController?.abort();
      this.resultsTarget.innerHTML = '';
      return;
    }

    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => this.#fetchResults(query), 300);
  }

  #fetchResults(query) {
    this.abortController?.abort();
    this.abortController = new AbortController();

    fetch(`${this.urlValue}?q=${encodeURIComponent(query)}`, {
      headers: { Accept: 'application/json' },
      signal: this.abortController.signal,
    })
      .then((r) => {
        if (!r.ok) throw new Error(`Search failed: ${r.status}`);
        return r.json();
      })
      .then((products) => {
        this.resultsTarget.innerHTML = '';
        products.forEach((p) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className =
            'list-group-item list-group-item-action d-flex justify-content-between align-items-center py-1 px-2';
          button.dataset.action = 'click->product-search#select';
          button.dataset.productId = p.id;

          const span = document.createElement('span');
          span.textContent = p.title + ' ';
          const small = document.createElement('small');
          small.className = 'text-muted';
          small.textContent = `(${p.source})`;
          span.appendChild(small);

          const badge = document.createElement('span');
          badge.className = 'badge bg-primary';
          badge.textContent = 'Add';

          button.appendChild(span);
          button.appendChild(badge);
          this.resultsTarget.appendChild(button);
        });
      })
      .catch((error) => {
        if (error.name === 'AbortError') return;
        this.resultsTarget.innerHTML = '';
      });
  }

  select(event) {
    const productId = event.currentTarget.dataset.productId;
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = this.#addProductUrl();

    const csrfMeta = document.querySelector('meta[name="csrf-token"]');
    const csrfToken = csrfMeta ? csrfMeta.content : '';
    const csrfInput = document.createElement('input');
    csrfInput.type = 'hidden';
    csrfInput.name = 'authenticity_token';
    csrfInput.value = csrfToken;
    form.appendChild(csrfInput);

    const pidInput = document.createElement('input');
    pidInput.type = 'hidden';
    pidInput.name = 'product_id';
    pidInput.value = productId;
    form.appendChild(pidInput);

    document.body.appendChild(form);
    form.submit();
  }

  #addProductUrl() {
    // Derive from current URL: /admin/comparisons/:slug/add_product
    const path = window.location.pathname.replace(/\/edit$/, '');
    return `${path}/add_product`;
  }
}
